import SettingSubscribe from './SettingSubscribe'

export default SettingSubscribe
